import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ChromePicker } from 'react-color';
import { useResume } from '../../context/ResumeContext';
import { FONT_FAMILIES, FONT_SIZES, MEMBERSHIP, PAID_SERVICES, POPUP_TYPES, DEFAULT_VARIANT_COLOR, DEFAULT_TEMPLATE_COLOR, OLD_COLOR_CODES, COVERLETTER_EXPERIENCE, APP_DOMAIN } from '../../constants/constants';
import Resumes from '../resumetemplates/Resumes';
import downloadResume from '../../downloadResume';
import { usePopup } from '../../context/PopupContext';
import WpAPI from '../../WpApi';
import SignUpPopup from '../user/SignUpPopup';
import RainblowPicker from '../../assets/images/ranbow-02.svg';
import { userCompletesSectionsDownloadsPrintsOrShares as userCompletesSectionsDownloadsPrintsOrSharesAction } from '../../services/actions/actions';
import { useUser } from '../../context/UserContext';
import initialData from '../../initial-data';
const StyleControls = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const popupbox = usePopup();
    const ddRef = useRef();
    const firstHit = useRef();
    const initialDataStyle = initialData.resume.styling;
    const [openFFDropDown, setOpenFFDropDown] = useState(false);
    const [customColor, setCustomColor] = useState('#000000');
    const [spinner, setSpinner] = useState(false);
    const [currIndex, setCurrIndex] = useState();
    const [showLoginPopUp, setShowLoginPopUp] =  useState(false);
    const [loader, setLoader] = useState({download: false, save: false, share: false});
    const [showColorPicker, setShowColorPicker] = useState(false);
    const [showEditOptions, setShowEditOptions] = useState(false);
    const [styleType, setStyleType] = useState('headingStyle');
    const [styleTypeAttr, setStyleTypeAttr] = useState(initialDataStyle.headingStyle);

    const {
        checkMembership,
        plan,
        user
    } = useUser();

    const {
        resume,
        setShowPreview,
        handlers: {
            updateResumePreview,
            //nuteralizeNextClick,
            //nuteralizeBackClick,
            onsaveResume,
            //deleteSection,
        },
        currentResume
    } = useResume();

    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);

    // const setCustomColor = (e) => {
    //     console.log(e);
    // }

    const styling = resume?.styling;

    //For Backworad Compatibility
    const getActiveStyle = type => {
        const activeStyle = {
            headingStyle: {
                fontSize: styling?.headingStyle.fontSize ?? resume.heading_font_size,
                fontFamily: styling?.headingStyle.fontFamily ?? resume.heading_font_family,
                textColor: styling?.headingStyle.textColor ?? resume.heading_color
            },
            subHeadingStyle: styling?.subHeadingStyle ?? initialDataStyle?.subHeadingStyle,
            textStyle: styling?.textStyle ?? initialDataStyle?.textStyle
        }
        return type ? activeStyle[type] : activeStyle
    }

    const updateStyleOptions = (val) => {
        // console.log(val, getActiveStyle(val));
        //console.log(headingStyle, subHeadingStyle, textStyle);
        setStyleType(val);
        setStyleTypeAttr(getActiveStyle(val));
        setTimeout(() => {
            setShowEditOptions(false);
        }, 50);
    }    

    const updateStyle = (style) => {
        const c = { ...styleTypeAttr, ...style }
        setStyleTypeAttr(c)

        updateResumePreview({
            styling: {
                ...getActiveStyle(),
                [styleType]: c,
            }
        }, true);

        //onsaveResume();
        setOpenFFDropDown(false);
    }
    
    const decreaseFontSize = () => {
        let index = getPrevIndex(styleTypeAttr.fontSize);
        if (index >= 0) {
            setCurrIndex(index);
            let fontSize = FONT_SIZES[index].id;
            updateStyle({ fontSize });
        }
    }
    const increaseFontSize = () => {
        let index = getNextIndex(styleTypeAttr.fontSize);
        if (index < FONT_SIZES.length) {
            setCurrIndex(index);
            let fontSize = FONT_SIZES[index].id;
            updateStyle({ fontSize });
        }
    }

    const getPrevIndex = (size) => {
        const index = FONT_SIZES.findIndex((font) => font.id === size);
        return index > 0 ? index - 1 : 0;
    }
    const getNextIndex = (size) => {
        const index = FONT_SIZES.findIndex((font) => font.id === size);
        return index < FONT_SIZES.length - 1 ? index + 1 : FONT_SIZES.length - 1;
    }
    const findIndex = (value) => {
        for (let i = 0; i < FONT_SIZES.length; i++) {
            if (FONT_SIZES[i].id == value) {
                return i;
            }
        }
        return 0;
    }
    const onClickOutside = (e) => {
        if (e.target.classList.value != 'block-name') {
            setOpenFFDropDown(false);
        }
        if (e.target.classList.value != 'ed-block-name') {
            setShowEditOptions(false);
        }
        if (e.target.classList.value != '') {
            setShowColorPicker(false);
        }
    }

    useEffect(() => {
        if (!firstHit.current && resume.styling && resume.heading.email != '') {
            setStyleTypeAttr(resume.styling[styleType]);
            firstHit.current = 'done'
        }
    }, [resume.styling, resume.heading.email]);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ddRef.current && !ddRef.current.contains(event.target)) {
                onClickOutside && onClickOutside(event);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [onClickOutside]);


    useEffect(() => {
        popupbox.configurePopup(POPUP_TYPES);
        let liveIndex = findIndex(resume.heading_font_size);
        setCurrIndex(liveIndex);

    }, []);

    const checkMembershipAction = (callback = false, params = false) => {
        if(typeof callback == 'function' && mounted.current) setLoader({...loader, [callback.name]: true});
        checkMembership(() => {
            if(typeof callback == 'function'){
                callback(params);
                if(mounted.current) setLoader({...loader, [callback.name]: false});
            }
        });
    }

    const downloadHandler = (downloadFormat) => {
        downloadResume({resume, currentResume, user}, user, () => { 
            popupbox.close('download');
            setTimeout(() => {
                popupbox.show('askfor_trustpilot_review', null, () => {
                    window.open( `https://www.trustpilot.com/review/resume.org`, '_blank');
                  });
              }, 3000); 
            // popupbox.show('downloadcompletionbox', null, () => {
            //     window.location.href = `${APP_DOMAIN}${COVERLETTER_EXPERIENCE}`;
            // });
        }, downloadFormat, {type: 'resume', name: 'Resume' });
        gaTrack('RB App', `Quick Editor`, 'Header Download');
        ga4Track('app_header_download', 'RB App', 'Header Download');
    }

    const getColorCode = (c) => {
        if(DEFAULT_VARIANT_COLOR[OLD_COLOR_CODES[resume.active_color]] == undefined){
            return c ? 
                c :
                (resume.custom_template_color ? 
                resume.custom_template_color : 
                (resume.active_color ? 
                DEFAULT_VARIANT_COLOR[resume.active_color]  : 
                DEFAULT_TEMPLATE_COLOR[resume.active_template]));
        } else {
            return c ? 
                c : 
                (resume.custom_template_color ? 
                resume.custom_template_color : 
                (resume.active_color ? 
                DEFAULT_VARIANT_COLOR[OLD_COLOR_CODES[resume.active_color]]  : 
                DEFAULT_TEMPLATE_COLOR[resume.active_template]));
        }
    }

    const download = () => {
        localStorage.setItem('clickAction', 'download');
        if(WpAPI.isLoggedIn()){
            // if(PAID_SERVICES){
            //     if(plan == 'pro'){
            //         popupbox.show('download', null, () => downloadHandler())
            //     }else history.push(MEMBERSHIP);
            // }else{
            //     popupbox.show('download', null, () => downloadHandler())
            // }
            /**
             * #775: Any logged in users can download the resume in the text format. 
             * Action: Removed the above code snippet having PAID_SERVICES and plan check.
             * Date: 2023-07-21
             */
            popupbox.show('download', null, (params) => {
                downloadHandler(params.downloadFormat);
                userCompletesSectionsDownloadsPrintsOrShares();
                ga4Track('app_header_menu_download', 'RB App', 'Download');
            }, {plan: plan, entity: {type: 'resume', name: 'Resume' }});
        }else{
            setShowLoginPopUp(true);
            WpAPI.setRedirectCookie(location.pathname);
        }
    }

    const userCompletesSectionsDownloadsPrintsOrShares = () => {
        dispatch(userCompletesSectionsDownloadsPrintsOrSharesAction({...resume}, 'currentResume')).then(res => {
            if(res.completed){
                const ec = (PAID_SERVICES && plan == 'pro' ? 'app_editor_finalizations' : 'app_editor_finalizations_free');
                const el = (
                    PAID_SERVICES && plan == 'pro' 
                    ? 'User completes sections: Downloads, Prints or Shares' 
                    : 'Free user completes sections: tries to download, print, share'
                );
                ga4Track(ec, 'RB App', el)
            }
        })
    }

    return (<div className="header-controls">
        <div className="dropdown-controls" style={{ display: 'none' }}>
            <div className="block-dd section-list">
                <div className="ed-block-name-wrap">
                    <span className="ed-block-name" onClick={() => {
                        setShowEditOptions(!showEditOptions);

                    }}><span className="name">{(styleType == 'textStyle' ? 'Edit Text' : (styleType == 'subHeadingStyle' ? 'Edit Sub-headers' : 'Edit Headers'))}</span>
                        <i className={showEditOptions ? `icon-right-arrow icon-up-arrow`:`icon-right-arrow`}></i>
                    </span>
                    {showEditOptions ? <div className="block-list" ref={ddRef}>
                        <ul>
                            <li onClick={() => {
                                updateStyleOptions('headingStyle');
                            }}>Edit Headers</li>
                            <li onClick={() => {
                                updateStyleOptions('subHeadingStyle');
                            }}>Edit Sub-headers</li>
                            <li onClick={() => {
                                updateStyleOptions('textStyle');
                            }}>Edit Text</li>
                        </ul>
                    </div> : ""}
                </div>
            </div>
            <div className="block-dd fontfamily-list">
                <div className="block-name-wrap">
                    <span className="block-name" onClick={() => {
                        setOpenFFDropDown(!openFFDropDown);
                    }}>
                        <span className="name">
                            {styleTypeAttr?.fontFamily?.length ? styleTypeAttr?.fontFamily : 'Select Font'}
                        </span>
                        <i className={openFFDropDown ? `icon-right-arrow icon-up-arrow`:`icon-right-arrow`}></i>
                    </span>
                    {openFFDropDown ? <div className="block-list" ref={ddRef}>
                        <ul className="list-1">
                            {FONT_FAMILIES.map((value, index) => {
                                return (
                                    <li 
                                        onClick={(e) => { 
                                            //updateFontFamily(value.id);
                                            updateStyle({ fontFamily: value.id });
                                            gaTrack('RB App', `Header Menu`, 'Change Font');
                                            ga4Track('app_header_menu_change_font', 'RB App', 'Change Font');
                                        }} 
                                        key={index}>{value.name}</li>
                                )
                            })}
                        </ul>
                    </div> : ''}
                </div>
            </div>

            <div className="block-dd color-picker-wrap">
                <div className="block-name-wrap">
                    <div className="head-color-picker" onClick={() => {
                        setShowColorPicker(true);
                    }}>
                        <span className="color-picker">
                            {<i className="color-square" style={{ backgroundColor: getColorCode(styleTypeAttr?.textColor) }}></i>}
                        </span>
                        {showColorPicker ? <div className="chrome-picker" style={{ top: '28px', right: '50%', transform: 'translate(50%, 0px)', position: 'absolute' }} ref={ddRef}>

                            <ChromePicker
                                color={getColorCode(styleTypeAttr?.textColor)}
                                onChange={(e) => { setCustomColor(e.hex) }}
                                onChangeComplete={(e) => {
                                    updateStyle({ textColor: e.hex });
                                    gaTrack('RB App', `Header Menu`, 'Change Color');
                                    ga4Track('app_header_menu_change_color', 'RB App', 'Change Color');
                                }}
                                disableAlpha={true}
                            />

                        </div> : ''}
                        <span className="color-code">{getColorCode(styleTypeAttr.textColor)}</span>
                        {/* <span className="cross" onClick={() => {
                            updateCustomColor('');
                        }}><i className="icon-cross-icon"></i></span> */}
                        {/* <input
                                type="color"
                                name="color"
                                value={resume?.heading_color ? resume.heading_color : DEFAULT_VARIANT_COLOR[resume.active_color]}
                                onChange={(e) => {
                                    updateCustomColor(e.target.value);
                                }} /> */}
                    </div>
                </div>
            </div>

            <div className="block-dd fontsize-list">
                <div className="block-name-wrap">
                    <span className="block-name fs">
                        <span className="minus-fs" onClick={() => {
                            currIndex >= 0 ? decreaseFontSize() : '';
                            if(currIndex >= 0){
                                gaTrack('RB App', `Header Menu`, 'Change Size');
                                ga4Track('app_header_menu_change_size', 'RB App', 'Change Size');
                            }
                        }}  data-acsb-navigable="true">-</span>
                        <span className="name">{
                            styleTypeAttr.fontSize?.length ? (styleTypeAttr.fontSize).replace('-', ' ') : 'Size'
                        }</span>
                        <span className="plus-fs" onClick={() => {
                            currIndex < FONT_SIZES.length ? increaseFontSize() : '';
                            if(currIndex < FONT_SIZES.length){
                                gaTrack('RB App', `Header Menu`, 'Change Size');
                                ga4Track('app_header_menu_change_size', 'RB App', 'Change Size');
                            }
                        }}   data-acsb-navigable="true">+</span>
                    </span>
                </div>
            </div>
        </div>

        {/* {!props.hidebuttons && <div className="button-link-wrap"> */}
            {/* <div className="button-link" onClick={()=>{setShowPreview(true); ga4Track('app_editor_preview', 'RB App', 'Preview');}} >
                <span className="preview-btn"><i className="icon-eye"></i>Preview</span>
            </div> */}
            {/* <div className="button-link">
                <span className="download-btn">
                    <i className="icon-download-2"></i> Dowload <i className="arrow icon-right-arrow"></i></span>
            </div> */}
            {/* <div className="button-link">
                <span className="download-btn" onClick={() => checkMembershipAction(download)}>
                    <i className="icon-download-2"></i> {loader.download ? 'Loading...' : 'Download'}
                </span>
            </div> */}
        {/* </div> } */}
        {showLoginPopUp && <SignUpPopup setShowLoginPopUp={(c) => { setShowLoginPopUp(c) }} />}
    </div>);
}

export default StyleControls;